<template>
    <section class="header-text-container">
        <div class="header-text">
            <!-- eslint-disable vue/no-v-html -->
            <div
                class="header-text__title"
                v-html="pageHeader.title"
            ></div>
            <div
                v-if="pageHeader.subtitle"
                class="header-text__subtitle"
                v-html="pageHeader.subtitle"
            ></div>

            <Media :type="pageHeader.media_type" />
        </div>
    </section>
</template>

<script setup>
import Media from '../../header-components/media/watson-theme-header-media.vue';

defineProps({
    pageHeader: {
        type: Object,
        required: false,
        default: null,
    },
});
</script>

<style lang="scss" scoped>
@use "watson-theme-header-text";
</style>
